import { Col, notification, Row, Card, Statistic, Flex } from "antd";
import { useState, useEffect } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import { getAggregateCogsCost } from "../utils/CogCost";

const ModalPSIAggregate = ({ psiId }) => {
	const [loading, setLoading] = useState(false);
	const [dataPlants, setDataPlants] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getDataTrips();
	}, []);

	const getDataTrips = async () => {
		setLoading(true);

		const url = api + `/aggregate/list/psi/${psiId}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let datas = [];
			data.map((item) => {
				const cogs = getAggregateCogsCost(item);
				const plant = item.plant.name;
				datas.push({
					cogs,
					plant,
				});
			});
			setDataPlants(datas);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderData = () => {
		return (
			<Row gutter={16}>
				{dataPlants.map((item) => (
					<Col span={12}>
						<Card variant="borderless">
							<Statistic
								title={item.plant}
								value={item.cogs}
								precision={2}
								prefix="$"
							/>
						</Card>
					</Col>
				))}
			</Row>
		);
	};

	return (
		<Flex vertical gap="large">
			{loading ? <CustomSpinner /> : <RenderData />}
			{contextHolder}
		</Flex>
	);
};

export default ModalPSIAggregate;
